module.exports = __webpack_public_path__ + "static/media/vatn.a1e15155.m4a";